import Vue from 'vue';
import WorkTooltip from '@/components/global_components/tooltip/WorkTooltip';

Vue.component('WTooltip', WorkTooltip);
